import React from 'react'
import api, { METHODS } from './api'
import Report, { newReport } from '../common/types/api/report'

import GlobalNotification from 'live/services/global-notification'
import { Notification } from '../common/components/Notification/Notification'
import i18n from 'live/services/i18n'
import { Sheet } from '../common/types/api/excel'

export default async function getHeaderInfo(sheet: Sheet): Promise<any> {
    try {
        const res = await api<newReport>(`headerInfo`, METHODS.POST, JSON.stringify(sheet))
        if (!res.success) {
            GlobalNotification.error(
                <Notification title={i18n('Error trying to delete Report: ')}>{'unknown error'}</Notification>,
                20
            )

            console.error(res)
        }

        return res as any
    } catch (error) {
        const errorMsg = i18n('Error trying to persist report: ')
        GlobalNotification.error(<Notification title={errorMsg}>{error}</Notification>, 20)
        console.error(errorMsg, error)

        return null
    }
}
